module.exports = __webpack_public_path__ + "img/Hp-jet-fusion-580.c98be22d.png";